/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';
import {getJSON} from '../constants/network';
import routes from '../constants/routes';
import PoiRating from './PoiRating';
import Poi from './Poi';
import Publicidad from './Publicidad';
import Vacio from './Vacio';

import 'bootstrap/dist/js/bootstrap.min';

const TYPE_POI = "POI";
const TYPE_PUB = "PUBLICIDAD";

export default class extends Component {
    state = {
        pois: [],
        publicidad: [],
        servicios: [],
        filtro: {
            costo: 0,
            servicios: [],
            valoracion: []
        }
    };

    filtrar = (poi, index) => {
        let condicionValoracion = true;
        let condicionServicios = true;
        let condicionCosto = true;
        let condicionFavorito = true;
        let condicionDestacado = true;
        if (this.state.filtro.valoracion && this.state.filtro.valoracion.length) {
            condicionValoracion = this.state.filtro.valoracion.indexOf(poi.valoracion) !== -1;
        }

        if (this.state.filtro.servicios && this.state.filtro.servicios.length) {
            condicionServicios = poi.servicios && poi.servicios.length > 0;
            if (condicionServicios) {

                let serviciosPoi = [];
                poi.servicios.forEach(function (s) {
                    serviciosPoi.push(s.id);
                });

                this.state.filtro.servicios.every(function (serv, index) {
                    condicionServicios = condicionServicios && serviciosPoi.indexOf(serv) !== -1;
                    return condicionServicios;
                });
            }
        }
        if (this.state.filtro.costo !== 0) {
            condicionCosto = condicionCosto && poi.rate === this.state.filtro.costo;
        }
        if (this.state.filtro.destacado) {
            condicionDestacado = poi.destacado;
        }
        if (this.state.filtro.favorito) {
            condicionFavorito = poi.favorito;
        }

        return (poi.tipo_elem === TYPE_POI && condicionDestacado && condicionFavorito &&
            condicionValoracion && condicionServicios && condicionCosto) || poi.tipo_elem === TYPE_PUB;
    }

    setFiltroCosto = (event) => {
        let value = event.target.value;
        let filtro = (JSON.parse(JSON.stringify(this.state.filtro)));
        filtro.costo = parseInt(value, 10);
        this.setState({
            filtro: filtro
        });
    }

    setFiltroValoracion = (event) => {
        let value = parseInt(event.target.value, 10);
        let filtro = (JSON.parse(JSON.stringify(this.state.filtro)));

        let nuevaValoracion = [];

        if (event.target.checked) {
            nuevaValoracion.push(value);
        }

        filtro.valoracion = nuevaValoracion;

        this.setState({
            filtro: filtro
        });
    }

    setFiltroServicios = (event) => {
        let value = event.target.value;
        let filtro = (JSON.parse(JSON.stringify(this.state.filtro)));

        let nuevosServicios = filtro.servicios;

        if (event.target.checked) {
            nuevosServicios.push(value);
        } else {
            nuevosServicios.splice(nuevosServicios.indexOf(value), 1);
        }

        filtro.servicios = nuevosServicios;

        this.setState({
            filtro: filtro
        });
    }

    setFiltroDestacado = (event) => {
        let filtro = (JSON.parse(JSON.stringify(this.state.filtro)));
        filtro.destacado = event.target.checked;
        this.setState({filtro: filtro});
    }

    setFiltroFavorito = (event) => {
        let filtro = (JSON.parse(JSON.stringify(this.state.filtro)));
        filtro.favorito = event.target.checked;
        this.setState({filtro: filtro});
    }

    loadFromNetwork = () => {
        getJSON(routes.servicioAll)
            .then(result => {
                this.setState({
                    servicios: result.data
                });
            });
    }

    componentDidMount = () => {
        this.loadFromNetwork();
        this.updateLista(this.props);
    }

    componentWillReceiveProps = (nextProps) => {
        this.updateLista(nextProps);
    }

    updateLista = (props) => {
        let lista = [];

        let nPois = props.pois.length;
        let nPublicidad = props.publicidad.length;
        let posPublicidad = 0;
        let poisMostrados = 0;

        props.pois.forEach((poi, index) => {
            poi.tipo_elem = TYPE_POI;
            lista.push(poi);
            poisMostrados++;

            let intervalo = 10;

            if (nPois >= intervalo) {
                if (poisMostrados % intervalo === 0) {
                    if (posPublicidad < nPublicidad) {
                        let pub = props.publicidad[posPublicidad++];
                        pub.tipo_elem = TYPE_PUB;
                        lista.push(pub);
                    }
                }
            } else {
                if (index === nPois - 1) {
                    if (posPublicidad < nPublicidad) {
                        let pub = props.publicidad[posPublicidad++];
                        pub.tipo_elem = TYPE_PUB;
                        lista.push(pub);
                    }
                }
            }
        });

        this.setState({lista});
    }

    render = () => {
        let _this = this;
        if (this.state.lista) {
            return (
                <div>
                    <div className="col-sm-3">
                        <div id="sector-menu">

                            <div className="panel-group" id="accordion">

                                <div className="panel panel-default panel-filtro-poi">
                                    <div className="panel-heading" role="tab">
                                        <h4 className="panel-title">
                                            <a href="#collapsePrecio" role="button" data-toggle="collapse"
                                               data-parent="accordion" className="collapsed">Precio
                                                <span className="fa fa-fw fa-caret-down pull-right"/>
                                                <span className="fa fa-fw fa-caret-up pull-right"/>
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="panel-collapse collapse" id="collapsePrecio">
                                        <div className="panel-body">

                                            <div className="form-group">
                                                <div className="radio">
                                                    <label><input name="filtro_costo" type="radio"
                                                                  onChange={(e) => this.setFiltroCosto(e)}
                                                                  defaultChecked={this.state.filtro.costo === 0}
                                                                  value="0"/>Todos</label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="radio">
                                                    <label><input name="filtro_costo" type="radio"
                                                                  onChange={(e) => this.setFiltroCosto(e)}
                                                                  defaultChecked={this.state.filtro.costo === 1}
                                                                  value="1"/>Económico</label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="radio">
                                                    <label><input name="filtro_costo" type="radio"
                                                                  onChange={(e) => this.setFiltroCosto(e)}
                                                                  defaultChecked={this.state.filtro.costo === 2}
                                                                  value="2"/>Intermedio</label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="radio">
                                                    <label><input name="filtro_costo" type="radio"
                                                                  onChange={(e) => this.setFiltroCosto(e)}
                                                                  defaultChecked={this.state.filtro.costo === 3}
                                                                  value="3"/>Alto</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default panel-filtro-poi">
                                    <div className="panel-heading" role="tab">
                                        <h4 className="panel-title">
                                            <a href="#collapseServicio" role="button" data-toggle="collapse"
                                               data-parent="accordion" className="collapsed">
                                                Servicios
                                                <span className="fa fa-fw fa-caret-down pull-right"/>
                                                <span className="fa fa-fw fa-caret-up pull-right"/>
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="panel-collapse collapse" id="collapseServicio">
                                        <div className="panel-body">
                                            {
                                                this.state.servicios.map(function (serv) {
                                                    return (
                                                        <div className="form-group" key={serv.id} data-toggle="tooltip"
                                                             data-placement="right" title={serv.descripcion}>
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input type="checkbox" value={serv.id}
                                                                           onChange={(e) => _this.setFiltroServicios(e)}/>{serv.nombre}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default panel-filtro-poi">
                                    <div className="panel-heading" role="tab">
                                        <h4 className="panel-title">
                                            <a href="#collapseValoracion" role="button" data-toggle="collapse"
                                               data-parent="accordion" className="collapsed">
                                                Valoración
                                                <span className="fa fa-fw fa-caret-down pull-right"/>
                                                <span className="fa fa-fw fa-caret-up pull-right"/>
                                            </a>
                                        </h4>
                                    </div>
                                    <div className="panel-collapse collapse" id="collapseValoracion">
                                        <div className="panel-body" id="filtro-valoracion">
                                            {
                                                [5, 4, 3, 2, 1].map(function (r) {
                                                    return (
                                                        <div className="form-group" key={r + "-Estrellas"}>
                                                            <div className="checkbox">
                                                                <label>
                                                                    <input type="checkbox" name={"valoracion-" + r}
                                                                           onChange={(e) => _this.setFiltroValoracion(e)}
                                                                           value={r}/>
                                                                    <PoiRating rating={r}/>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default panel-filtro-poi">
                                    <div className="panel-collapse" id="collapseDestacadoFavorito">
                                        <div className="panel-body" id="filtro-valoracion">
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox" onChange={(e) => _this.setFiltroFavorito(e)}
                                                               value="1"/>
                                                        Favorito de Valentina
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="checkbox">
                                                    <label>
                                                        <input type="checkbox" onChange={(e) => _this.setFiltroDestacado(e)}
                                                               value="1"/>
                                                        Punto Destacado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="lista-pois" className="col-sm-9">
                        <ul>
                            {
                                this.state.lista.filter(this.filtrar).map(function (data) {
                                    let destacado = "";
                                    if (data.destacado){
                                        destacado="poi-destacado "
                                    }
                                    if(data.tipo_elem === TYPE_POI) {
                                        return (
                                            <li key={`${data.id}poi`} className={destacado + " item-lista-poi"}>
                                                <Poi poi={data}
                                                     showEstado={_this.props.showEstado}
                                                     showSector={_this.props.showSector}
                                                     showRuta={_this.props.showRuta}/>
                                            </li>
                                        )
                                    }
                                    return <li key={`${data.id}pub`} className="item-lista-pub"><Publicidad
                                        publicidad={data}/></li>
                                })
                            }
                        </ul>
                    </div>
                </div>
            )
        }
        return <Vacio/>
    }
}


// WEBPACK FOOTER //
// ./src/components/ListaPoi.js